import React, { useEffect, useState } from 'react'
import { Box, Grid, Paper, TableRow, Typography } from '@mui/material'
import { showLoader } from '../Redux/Slices/loaderSlice'
import { getAvailableAccess, getNotification, getNotifications } from '../Redux/Actions/action'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import CommonTable from '../Components/Common/CommonTable'
import StyledTableCell from '../Components/Common/styledTableCell'
import DataNotFound from '../Components/Common/DataNotFound'
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CustomPagination from '../Components/Common/CommonPagination'
import ErrorHandler from '../Utils/handler'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import TextLabel from '../Components/Common/CommonTextLabel'


const Notifications = () => {
  // ---------- Hook -----------
  // const dataAccess = useSelector(value => value?.allAvailableAccess?.AllAvailableAccessList)
  // const dispatch = useDispatch();
  // const tableHeaders = ["No", "Notification", "Date"]


  // --------------- State -------------
  // const [page, setPage] = useState(1);
  // const [rowsPerPage, setRowsPerPage] = useState(25);
  // const [data, setData] = useState([]);

  // --------------- handleChange ---------------
  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(1);
  // };

  // --------------- Api  ---------------
  // const _getNotificationData = async () => {
  //   dispatch(showLoader(true))
  //   let body = {
  //     page: page,
  //     limit: rowsPerPage,
  //   }
  //   try {
  //     const result = await dispatch(getNotifications(body));
  //     const error = ErrorHandler(result);
  //     if (error) {
  //       setData(result?.payload?.data);
  //     }
  //   } catch (error) {
  //     toast.error(error);
  //   } finally {
  //     dispatch(showLoader(false));
  //   }
  // }

  // // ---------- useEffect -----------
  // useEffect(() => {
  //   _getNotificationData();
  // }, [])

  // useEffect(() => {
  //   dispatch(showLoader(true));
  //   dispatch(getAvailableAccess())
  //     .unwrap() // Automatically handles async response
  //     .catch((error) => console.error("error", error))
  //     .finally(() => dispatch(showLoader(false)));
  // }, [dispatch]);

  return (
    <>
      {/* <Grid container spacing={2} xs={12} >
        <Grid item xs={12}>
          <Paper elevation={0} sx={{ padding: 2, background: { md: "#fff", xs: "none" } }}>

            <Typography sx={{ fontSize: { lg: 24, md: 20, xs: 18 } }} fontWeight={"medium"} color={"#3E4094"}>Notifications</Typography>

            <CommonTable headerList={tableHeaders} align={'center'} minWidth={600}>

              {data?.data?.length > 0 ? data?.data?.map((not, index) => {
                return (
                  <TableRow key={index}>

                    <StyledTableCell align="center">{(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}</StyledTableCell>

                    <StyledTableCell align="center">
                      <Box display={"flex"} flexDirection={"column"} textAlign={"center"} justifyContent={"center"}>
                        <TextLabel textAlign={"center"} fontSize={"14px"} fontWeight={"600"} title={not?.subTitle} />
                        <TextLabel textAlign={"center"} fontSize={"14px"} title={not?.description} />
                      </Box>
                    </StyledTableCell>

                    <StyledTableCell align="center">{dayjs(not?.date)?.format("DD/MM/YYYY") || "-"}</StyledTableCell>

                  </TableRow>
                )
              }) :
                (
                  <TableRow>
                    <StyledTableCell colSpan={11}>
                      <DataNotFound title={'No Records Found'} icon={<ErrorOutlineIcon color="primary" style={{ fontSize: "3rem" }} />} elevation={0} />
                    </StyledTableCell>
                  </TableRow>
                )
              }
            </CommonTable>

            {data?.count > 0 &&
              <Grid item xs={12}>
                <CustomPagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  count={Math.ceil(data?.count / rowsPerPage)}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage} />

              </Grid>
            }
          </Paper>

        </Grid>

      </Grid > */}
    </>
  )
}

export default Notifications
